// TopNotification.js
import React from "react";
import { Alert, Chip, Slide } from "@mui/material";
import { Link } from "react-router-dom";

export const LimitNotification = ({
  open,
  severity,
  message,
  onClose,
  onExtend,
}) => {
  return (
    <Slide in={open} direction="down" mountOnEnter unmountOnExit>
      <Alert
        severity={"warning"}
        onClose={onClose}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          borderRadius: 0,
          zIndex: 1300,
          textAlign: "center",
        }}
      >
        {message}
        {onExtend && (
          <span
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={onExtend}
          >
            <Chip
              sx={{ backgroundColor: "#74c69d" }}
              label="Extend limit."
              size="small"
            />
          </span>
        )}
      </Alert>
    </Slide>
  );
};
